import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { AnalyzeProjectValidation } from "../../../../utils/schema";
import { useFormik } from "formik";
import SteppersUI from "../../../../components/newStepper/NewStepper";
import { useDispatch } from "react-redux";
import {
  analyzeNetworkProject,
  getEnvironmentConfig,
  getNetworkSummery,
} from "../../../../redux/node/actions";
import { getActiveStep } from "../../../../redux/test/actions";
import { useNavigate } from "react-router";
// import OpenWithIcon from '@mui/icons-material/OpenWith';

// Styles for the vertical line
const verticalLine = {
  background:
    "radial-gradient(50% 50% at 50% 50%, rgba(1, 62, 183, 0.31) 0%, rgba(255, 255, 255, 0) 100%)",
  height: "400px",
  width: 2,
  display: { xs: "none", sm: "none", md: "block" },
};
// Styles for the button container
const buttonBox = {
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
  mt: 4,
};
// Styles for the buttons
const button = {
  borderRadius: "5px",
  maxWidth: "7.2rem",
  width: "100%",
  ml: ".5rem",
};
// NetworkSummary component
const NetworkSummaryAi = ({ setScreen }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();

  const formik = useFormik({
    initialValues: {
      projectName: "",
      industry: "",
      projectDescription: "",
    },
    validationSchema: AnalyzeProjectValidation,

    onSubmit: async (values) => {
      try {
        setLoading(true);
        // Dispatch the API call
        await dispatch(analyzeNetworkProject(values, navigate));
        setScreen(1);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleBack = () => {
    dispatch(getActiveStep(0));

    navigate('/');
  };

  return (
    <React.Fragment>
      <Box>
        <Box
          sx={{
            mt: ".5rem",
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {/* Stepper component */}
          <Box sx={{ maxWidth: "600px ", width: "100%" }}>
            <SteppersUI isAI={true} />
          </Box>
        </Box>
        {/* Network summary heading */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // alignItems: "center",
            flexDirection: { xs: "column", sm: "column", md: "row" },
          }}
        >
          <Box
            sx={{ width: { xs: "100%", sm: "100%", md: "48%" }, mt: "37px" }}
          >
            <Typography
              variant="h1"
              sx={{
                m: { xs: "1rem 0", sm: " 0 0rem 1rem", textTransform: "none" },
              }}
            >
              {/* Wellcome to your AI power blockchain Advisor */}
              Welcome to Your AI-Powered
            </Typography>
            <Typography
              variant="h1"
              sx={{
                m: { xs: "1rem 0", sm: " 0 0rem 1rem", textTransform: "none" },
              }}
            >
              Blockchain Advisor
            </Typography>
            <Typography variant="subtitle1" textAlign="left">
              {/* Our AI Blockchain Advisor helps you configure a secure and reliable private blockchain by recommending the optimal node setup for your network. */}
              Our AI-powered Blockchain Advisor analyzes your project
              requirements and intelligently recommends the optimal blockchain
              platform and configuration for your specific use case. Using
              advanced language models, the system evaluates your project's
              technical needs, industry requirements, and scalability goals to
              provide comprehensive blockchain architecture recommendations.
            </Typography>
          </Box>
          <Box sx={verticalLine} />

          <Box
            sx={{
              width: { xs: "100%", sm: "100%", md: "48%" },
              mt: { xs: 3, md: "37px" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: ".6rem",
              }}
            >
              <Typography
                variant="h1"
                sx={{ m: { xs: "1rem 0", sm: " 0 0rem 1rem" } }}
              >
                {" "}
                Enter Project Details
              </Typography>
            </Box>
            {/* Form */}
            <form
              onSubmit={formik.handleSubmit}
              style={{
                width: "100%",
              }}
            >
              <Box
                sx={{ width: "100%", maxHeight: "80px", height: "100%", mt: 1 }}
              >
                <TextField
                  autoComplete="off"
                  label="Project Name"
                  placeholder="Enter Your Project Name"
                  variant="outlined"
                  fullWidth
                  type="text"
                  sx={{ mt: 3 }}
                  name="projectName"
                  value={formik.values.projectName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.projectName &&
                    Boolean(formik.errors.projectName)
                  }
                  helperText={
                    formik.touched.projectName && formik.errors.projectName
                  }
                />
              </Box>
              <Box
                sx={{ width: "100%", maxHeight: "80px", height: "100%", mt: 1 }}
              >
                <FormControl fullWidth sx={{ mt: 3 }}>
                  <InputLabel
                    sx={{
                      color:
                        formik.touched.industry && formik.errors.industry
                          ? theme.palette.error.main
                          : theme.palette.text.primary,
                      "&.Mui-focused": { color: theme.palette.primary.main },
                    }}
                    id="industry-label"
                  >
                    Industry / Sector
                  </InputLabel>
                  <Select
                    labelId="industry-label"
                    placeholder="Choose Industry/Sector"
                    id="industry"
                    name="industry"
                    value={formik.values.industry}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.industry && Boolean(formik.errors.industry)
                    }
                    label="Industry / Sector"
                    onChange={(e) =>
                      formik.setFieldValue("industry", e.target.value)
                    }
                    MenuProps={{
                      disablePortal: true,
                      PaperProps: {
                        style: { maxHeight: 200 },
                      },
                      disableScrollLock: true,
                    }}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor:
                          formik.touched.industry && formik.errors.industry
                            ? theme.palette.error.main
                            : theme.palette.grey[400],
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.primary.main,
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.primary.main,
                      },
                      "& .MuiSelect-select": {
                        color: theme.palette.text.primary,
                      },
                    }}
                  >
                    <MenuItem value="defi">
                      DeFi (Decentralized Finance)
                    </MenuItem>
                    <MenuItem value="gaming">Gaming</MenuItem>
                    <MenuItem value="nft">NFT / Digital Art</MenuItem>
                    <MenuItem value="supply_chain">Supply Chain</MenuItem>
                    <MenuItem value="healthcare">Health Care</MenuItem>
                    <MenuItem value="social_media">Social Media</MenuItem>
                    <MenuItem value="enterprise">Enterprise / Private</MenuItem>
                    <MenuItem value="others">Others</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ width: "100%", height: "100%", mt: 1 }}>
                <TextField
                  autoComplete="off"
                  label="Use Case Description"
                  placeholder="Enter your use case description"
                  name="projectDescription"
                  value={formik.values.projectDescription}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={6}
                  type="text"
                  sx={{
                    mt: 3,
                    "& .MuiOutlinedInput-root": {
                      "& .MuiOutlinedInput-input": {
                        paddingLeft: 0,
                        paddingRight: 0,
                      },
                      "&.Mui-focused .MuiOutlinedInput-input": {
                        paddingLeft: 0,
                        paddingRight: 0,
                      },
                      "& textarea": {
                        resize: "vertical",
                        maxHeight: "40rem",
                        minHeight: "1rem",
                      },
                    },
                  }}
                  error={
                    formik.touched.projectDescription &&
                    Boolean(formik.errors.projectDescription)
                  }
                  helperText={
                    formik.touched.projectDescription &&
                    formik.errors.projectDescription
                  }
                  InputLabelProps={{
                    sx: {
                      color:
                        formik.touched.projectDescription &&
                        formik.errors.projectDescription
                          ? "red"
                          : theme.palette.text.gray,
                    },
                  }}
                />
              </Box>

              <Box sx={buttonBox}>
                <Button
                  variant="text"
                  data-cy="NetworkSummary-btn"
                  sx={button}
                  onClick={handleBack}
                >
                  cancel
                </Button>
                {/* Buuton to submit the formik form */}
                <Button
                  type="submit"
                  data-cy="NetworkSummary-Next"
                  disabled={
                    !formik.values.projectName ||
                    // !formik.values.industry ||
                    !formik.values.projectDescription ||
                    Object.keys(formik.errors).length > 0 ||
                    loading
                  }
                  variant="contained"
                  sx={button}
                >
                  {!loading ? "Analyze" : <CircularProgress size="1.7rem" />}
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default NetworkSummaryAi;
